import { getCartAnalytics, getItemsAnalytics, getTransactionAnalytics } from '@ynap/analytics'

export const trackProceed = (props) => {
    const cart = getCartAnalytics(props) || {}
    return {
        event: 'proceed to purchase',
        effect: 'enter payment',
        category: {
            primaryCategory: 'payment',
            subCategory: 'basket',
        },
        attributes: {
            position: 'basket',
        },
        cart,
        transaction: getTransactionAnalytics(props.checkoutAnalytics)
    }
}

export const trackContinue = (checkoutAnalytics) => {
    return {
        event: 'continue shopping',
        effect: 'navigation',
        category: {
            primaryCategory: 'ecommerce',
            subCategory: 'basket',
        },
        attributes: {
            position: 'basket',
        },
        transaction: getTransactionAnalytics(checkoutAnalytics)
    }
}

export const trackRemoveAllItems = (item, total, checkoutAnalytics) => {
    const itemAnalytics = getItemsAnalytics([item])[0] || {}
    const eventSuffix = total <= 1 ? 'all' : 'some'
    const removeItem = {
        event: `remove from cart - ${eventSuffix}`,
        effect: 'update cart',
        category: {
            primaryCategory: 'ecommerce',
            subCategory: 'basket',
        },
        item: [
            {
                ...itemAnalytics,
            },
        ],
        transaction: getTransactionAnalytics(checkoutAnalytics)
    }

    return removeItem
}

export const trackMoveToWishlist = (lineItem, checkoutAnalytics) => {
    return {
        event: 'remove from cart - move to wishlist',
        effect: 'update cart',
        category: {
            primaryCategory: 'ecommerce',
            subCategory: 'basket',
        },
        item: getItemsAnalytics([lineItem]),
        transaction: getTransactionAnalytics(checkoutAnalytics)
    }
}
